<template>
  <nav
    class="pagination"
    role="navigation"
    aria-label="pagination"
  >
    <ul class="pagination-list">
      <li>
        <a
          @click="$emit('select-page', 0)"
          class="pagination-link"
          :class="{ 'is-current': 0 === currentPage }"
        >1</a>
      </li>
      <li>
        <span
          class="pagination-ellipsis"
          v-if="middleNumbers && middleNumbers[0] !== 2"
        >&hellip;</span>
      </li>
      <li
        v-for="number in middleNumbers"
        :key="number"
      >
        <a
          @click="$emit('select-page', number - 1)"
          class="pagination-link"
          :class="{ 'is-current': number - 1 === currentPage }"
        >{{ number }}</a>
      </li>
      <li>
        <span
          class="pagination-ellipsis"
          v-if="
            middleNumbers &&
            middleNumbers[middleNumbers.length - 1] + 1 < lastPage
          "
        >&hellip;</span>
      </li>
      <li>
        <a
          @click="$emit('select-page', lastPage - 1)"
          class="pagination-link"
          v-if="lastPage"
          :class="{ 'is-current': lastPage - 1 === currentPage }"
        >{{ lastPage }}</a>
      </li>
    </ul>
  </nav>
</template>

<script lang="ts">
import { defineComponent } from "vue"

/** Pagination */
export default defineComponent({
  props: {
    /** Total amount of pages */
    numberOfPages: Number,
    /** Current page number */
    currentPage: Number,
  },
  computed: {
    lastPage() {
      if (this.numberOfPages === 1) {
        return null
      }
      return this.numberOfPages
    },
    middleNumbers() {
      if (this.numberOfPages < 3) {
        return null
      } else if (this.numberOfPages === 3) {
        return [2]
      } else if (this.numberOfPages === 4) {
        return [2, 3]
      } else {
        return [
          Math.min(Math.max(this.currentPage, 2), this.lastPage - 3),
          Math.min(Math.max(this.currentPage + 1, 3), this.lastPage - 2),
          Math.min(Math.max(this.currentPage + 2, 4), this.lastPage - 1)]
      }
    }
  }
})
</script>